import React, { createContext, useContext, useState } from 'react';
import SubscriptionModal from '../components/Subscription/SubscriptionModal';
// Stripe initialization removed for main flow.
// If SubscriptionModal still needs it internally, it handles it.

const SubscriptionContext = createContext();

export const useSubscription = () => useContext(SubscriptionContext);

export const SubscriptionProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openSubscriptionModal = () => setIsOpen(true);
  const closeSubscriptionModal = () => setIsOpen(false);

  return (
    <SubscriptionContext.Provider value={{ openSubscriptionModal, closeSubscriptionModal }}>
      {children}
      {isOpen && (
        <SubscriptionModal onClose={closeSubscriptionModal} />
      )}
    </SubscriptionContext.Provider>
  );
};
